export { EloSepaIcon } from './sepa-icon'
